import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "user-34ap-",
  "use": "user-34ap--usage",
  "viewBox": "0 0 19 19",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19 19\" id=\"user-34ap-\"><path d=\"M19 17.006c0-.968-.626-1.79-1.495-2.081-.069-.023-4.518-1.16-5.155-2.424-.29-.577-.004-1.317.286-1.828.133-.178.263-.367.388-.566.753-1.207 1.329-2.793 1.387-4.754C14.5 2.403 12.217.007 9.506 0 6.784.007 4.501 2.403 4.59 5.353c.059 1.961.633 3.547 1.387 4.753.125.2.255.389.387.568.29.51.577 1.25.286 1.827-.636 1.264-5.086 2.4-5.154 2.424A2.196 2.196 0 0 0 0 17.007V19h19v-1.994z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol